import { Radio } from "shared/components";

export const InvitationRadioType = ({
  type,
  title,
  description,
  checked,
  onChange
}: {
  type: "self-serve" | "manual";
  title: string;
  description: string;
  checked: boolean;
  onChange: () => void;
}) => (
  <Radio
    className="!items-start"
    label={
      <div className="-mt-1">
        <p className="text-base font-medium text-content-700">{title}</p>
        <p className="text-sm text-content-400">{description}</p>
      </div>
    }
    checked={checked}
    onChange={onChange}
    id={type}
    name="application-type"
  />
);
